import { css } from 'styled-components';

export const themeTokens = {
  checkoutTemplate: {
    wrapper: css``,
  },
  joinVipAnnual: {
    shared: {
      styledText: css``,
      learnMoreLink: css``,
    },
  },
  basketItemPrice: {
    basketPrice: css``,
    priceLabel: css``,
  },
  basketItemDetails: {
    basketPricePromo: css``,
  },
  basketItem: {
    productName: css``,
  },
  basicModal: {
    dialogStyle: css``,
  },
  productDetailName: {
    productName: css``,
  },
  productDetailHeader: {
    promoTextWrapper: css``,
  },
  productDetailSizeSelector: {
    sizeCategoryLabel: css``,
  },
  colorSwatch: {
    colorTitle: css``,
  },
  quickViewModal: {
    updateButton: css``,
    styledLink: css``,
  },
};
